import React, {
  ChangeEvent,
  forwardRef,
  HTMLProps,
  KeyboardEvent,
  ReactNode,
  Ref,
} from 'react'

import Text from 'Components/UI/Text'

import { Container, StyledInput, Wrapper, WrapperProps } from './styles'

type Props = WrapperProps & {
  caption?: string
  required?: boolean
  label?: ReactNode
  placeholder?: string
  danger?: boolean
  disabled?: boolean
  type?: HTMLProps<HTMLInputElement>['type']
  defaultValue?: string | number
  value?: string | number
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void
  onBlur?: () => void
  onClick?: () => void

  // TODO: outdated
  inverse?: boolean
  isMulti?: boolean
  small?: boolean
  renderBeforeElement?: () => void
}

function Input(
  {
    caption,
    compact,
    danger,
    defaultValue,
    disabled,
    label,
    placeholder,
    required,
    type = 'text',
    value,
    onChange,
    onKeyDown,
    onBlur,
    onClick,
    ...rest
  }: Props,
  ref?: Ref<HTMLInputElement>,
) {
  return (
    <Wrapper {...rest} compact={compact} danger={danger}>
      {label && <Text caption>{label}</Text>}

      <Container compact={compact} danger={danger}>
        <StyledInput
          defaultValue={defaultValue}
          disabled={disabled}
          placeholder={placeholder}
          ref={ref}
          required={required}
          type={type}
          value={value}
          onBlur={onBlur}
          onChange={onChange}
          onClick={onClick}
          onKeyDown={onKeyDown}
        />
      </Container>

      {caption && (
        <Text caption mt={2}>
          {caption}
        </Text>
      )}
    </Wrapper>
  )
}

export default forwardRef(Input)
